




























































































































































































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import ReminderForm from "@/components/forms/ReminderForm.vue";
import GroupForm from "@/components/forms/GroupForm.vue";
import EdgeForm from "@/components/forms/EdgeForm.vue";
import * as _ from "lodash";

import Configuration from "@/shared/Configuration";
import ModelFactory from "@/shared/models/modelFactory";
import {EntityType} from "@/shared/models/entityType";
import {INodeModel} from "@/shared/models/abstract/INodeModel";
import {IEdgeModel} from "@/shared/models/abstract/IEdgeModel";
import EdgeBaseModel from "@/shared/models/abstract/edgeBaseModel";
import NodeBaseModel from "@/shared/models/abstract/nodeBaseModel";
import {IDataService} from "@/shared/DataService/IDataService";
import {DefaultEdgeModel} from "@/shared/models/defaultEdge";
import Confirmation from "@/components/Confirmation.vue";
import {IRootModel} from "@/shared/models/abstract/IRootModel";
import PersonForm from "@/components/forms/PersonForm.vue";
import NoteForm from "@/components/forms/NoteForm.vue";

@Component({
    components: {
        "reminder-form": ReminderForm,
        "group-form": GroupForm,
        "edge-form": EdgeForm,
        "confirmation": Confirmation,
        "person-form": PersonForm,
        "note-form": NoteForm,
    }
})
export default class NavigatorPage extends Vue {
    currentComponent: any = null;
    mainSearchItems: any[] = null;
    mainSearchInput: string = null;
    mainSelected: any = null;
    parentGroupSelected: any = null;
    parentGroupSearchItems: any[] = null;
    isParentGroupSearchLoading: boolean = false;
    parentGroupSearchInput: string = null;
    isMainSearchLoading: boolean = false;
    incomingDrawerVisible: boolean = false;
    outgoingDrawerVisible: boolean = false;
    entityType: string = null;
    dataService: IDataService = null;
    isNewModel: boolean = false;
    parentHierarchy: any[] = [];
    groupChildren: any[] = null;
    groupChildrenVisible: boolean = false;
    parents: any[] = null;
    children: any[] = null;
    parentsVisible: boolean = false;
    childrenVisible: boolean = false;
    ancestorSelected: any = null;
    ancestorSearchItems: any[] = null;
    isAncestorSearchLoading: boolean = false;
    ancestorSearchInput: string = null;
    successorSelected: any = null;
    successorSearchItems: any[] = null;
    isSuccessorSearchLoading: boolean = false;
    successorSearchInput: string = null;
    isParentGroupVisible: boolean = false;
    isMainVisible: boolean = false;
    childSelected: any = null;
    childSearchItems: any[] = null;
    isChildSearchLoading: boolean = false;
    childSearchInput: string = null;
    edgePanelVisible: boolean = false;
    sourceNode: INodeModel = null;
    targetNode: INodeModel = null;
    initialPanel: boolean = true;
    isNotificationVisible: boolean = false;
    notificationText: string = null;
    initialItems: INodeModel[] = [];
    someReminders: INodeModel[] = [];
    notificationTimeout: number = 0;
    notificationColor: string = null;
    private formMap: { [key: string]: string } = {};
    col1: number = 12;
    col2: number = 0;
    layoutIcon: string = "mdi-arrow-collapse-all";

    // region Global

    get history() {
        return this.$store.state.history.getAll();
    }

    /**
     * Gets the recently used items in the current plex.
     */
    get recent() {
        return this.$store.state.recent;
    }


    /**
     * Toggles between the panels on the right and below the main form.
     */
    toggleColumnLayout() {
        if (this.col1 === 12) {
            this.col1 = 7;
            this.col2 = 5;
            this.layoutIcon = "mdi-arrow-expand-all";
        } else {
            this.col1 = 12;
            this.col2 = 0;
            this.layoutIcon = "mdi-arrow-collapse-all";
        }
    }

    async mounted() {
        this.dataService = await Configuration.getDataService(this.$store);
        this.setFormMapping();
        this.init();
        const self = this;
        // TODO: keyboard shortcuts
        window.addEventListener("keydown", function (event) {
            // NOTE: metaKey == Command on Mac
            if ((event.metaKey || event.ctrlKey) && event.keyCode === "L".charCodeAt(0)) {
                event.preventDefault();
                // TODO: is there a better way to set focus?
                (self.$refs.searchBox as any).$el.getElementsByTagName("input")[0].focus()
            } else if ((event.metaKey || event.ctrlKey) && event.keyCode === "S".charCodeAt(0)) {
                event.preventDefault();
                self.save();
            } else if ((event.metaKey || event.ctrlKey) && event.key === "[") {
                event.preventDefault();

                self.backwardInHistory();
            } else if ((event.metaKey || event.ctrlKey) && event.key === "]") {
                event.preventDefault();
                self.forwardInHistory();
            }
        })
    }

    get size() {
        const size = {xs: "x-small", sm: "small", lg: "large", xl: "x-large"}[this.$vuetify.breakpoint.name];
        return size ? {[size]: true} : {}
    }

    /**
     * Defines how an {@link EntityType} is mapped to a form.
     */
    setFormMapping() {
        this.formMap[EntityType.Reminder] = "reminder-form";
        this.formMap[EntityType.Note] = "note-form";
        this.formMap[EntityType.Group] = "group-form";
        this.formMap[EntityType.DefaultEdge] = "edge-form";
        this.formMap[EntityType.Person] = "person-form";
    }

    get entityIcon() {
        if (!this.isEntityPresent) {
            return null;
        }
        return this.getIcon(this.entity.entityType);
    }

    getIcon(entityType: EntityType | string) {
        switch (entityType) {
            case EntityType.Person:
                return "mdi-account";
            case EntityType.Group:
                return "mdi-select-group";
            case EntityType.DefaultEdge:
                return "mdi-link-variant";
            case EntityType.Reminder:
                return "mdi-progress-check";
            case EntityType.Note:
                return "mdi-pencil";
            default:
                return "mdi-svg";
        }
    }

    /**
     * Gets the current entity being edited.
     * @returns {IRootModel}
     */
    get entity(): IRootModel {
        if (_.isNil(this.$store.state.selectedModel)) {
            return null;
        } else {
            return this.$store.state.selectedModel;
        }
    }

    /**
     * Returns whether the current entity is a node.
     * @returns {boolean}
     */
    get isNode() {
        if (_.isNil(this.$store.state.selectedModel)) {
            return false;
        } else {
            return !_.isNil((this.$store.state.selectedModel as any).isFavorite);
        }
    }

    /**
     * Returns whether the current entity is an edge.
     * @returns {boolean}
     */
    get isEdge() {
        if (_.isNil(this.$store.state.selectedModel)) {
            return false;
        } else {
            return _.isNil((this.$store.state.selectedModel as any).isFavorite);
        }
    }

    /**
     * Returns whether the current entity is a group.
     * @returns {boolean}
     */
    get isGroup() {
        if (_.isNil(this.$store.state.selectedModel)) {
            return false;
        } else {
            return this.$store.state.selectedModel.isGroup;
        }
    }

    /**
     * Returns whether there currently is an entity being edited.
     * @returns {boolean}
     */
    get isEntityPresent() {
        return !_.isNil(this.$store.state.selectedModel);
    }

    /**
     * Gets the color for the favorite toggle.
     * @returns {string}
     */
    get favoriteColor() {
        if (_.isNil(this.$store.state.selectedModel)) {
            return null;
        } else {
            return this.$store.state.selectedModel.isFavorite ? "red" : null;
        }
    }

    /**
     * Returns rows of favorites to display.
     * @returns {any[]}
     */
    get rowsOfFavorites(): INodeModel[][] {
        let rows = [];
        let cols: INodeModel[] = [];
        for (let i = 0; i < this.initialItems.length; i++) {
            if (i % 4 === 0 && i > 0) {
                rows.push(cols);
                cols = [];
            }
            cols.push(this.initialItems[i]);
        }
        if (cols.length > 0) {
            rows.push(cols);
        }
        return rows
    }

    /**
     * Initializes the display.
     */
    init() {
        this.$store.dispatch("selectedModel", null);
        this.showEditPanels();
    }

    /**
     * Removes the current entity.
     */
    async deleteCurrentEntity() {
        if (_.isNil(this.entity)) {
            return;
        }
        if (this.isNewModel) { // has not been merged into the store
            return;
        }
        switch (this.entity.entityType) {
            case EntityType.Group:
                await this.deleteGroup();
                break;
            case EntityType.DefaultEdge:
                await this.deleteEdge();
                break;
            default:
                await this.deleteNode();
                break;
        }
    }

    /**
     * Removes the current group.
     */
    async deleteGroup() {
        this.removeEntityInHistoryAndRecent(this.entity);
        await this.dataService.removeGroup(this.entity as INodeModel);
        await this.$store.dispatch("selectedModel", null);
        this.showEditPanels();
    }


    /**
     * Removes a generic node (not a group).
     */
    async deleteNode() {
        this.removeEntityInHistoryAndRecent(this.entity);
        await this.dataService.removeNode(this.entity as INodeModel);
        await this.$store.dispatch("selectedModel", null);
        this.showEditPanels();
    }

    /**
     * Removes the current edge.
     */
    async deleteEdge() {
        this.removeEntityInHistoryAndRecent(this.entity);
        await this.dataService.removeEdge(this.entity as IEdgeModel);
        await this.$store.dispatch("selectedModel", null);
        this.showEditPanels();
    }

    /**
     * Removes the deleted entity from the history stack if present.
     */
    async removeEntityInHistoryAndRecent(entity: IRootModel) {
        await this.$store.dispatch("removeFromHistory", entity);
        await this.$store.dispatch("removeFromRecent", entity);
    }

    async backwardInHistory() {
        if (this.$store.state.history.canMoveBackward) {
            await this.$store.dispatch("backwardInHistory");
            const current = this.$store.state.getters.current;
            if (current.sourceId) {
                this.editEdge(current.id, false);
            } else {
                this.editNode(current.id, false);
            }
        }
    }

    async forwardInHistory() {
        if (this.$store.state.history.canMoveForward) {
            await this.$store.dispatch("forwardInHistory");
            const current = this.$store.state.getters.current;
            if (current.sourceId) {
                this.editEdge(current.id, false);
            } else {
                this.editNode(current.id, false);
            }
        }
    }

    /**
     * Saves whatever is current being edited.
     * @returns {Promise<void>}
     */
    async save(notify: boolean = true): Promise<boolean> {
        if (this.isNewModel) {
            // checking whether the name is already in the plex
            const found = await this.dataService.nameExists(this.entity.name);
            if (!_.isNil(found)) {
                if (await (this.$refs.confirm as any).open("Are you sure?", `There already is an entity (${found.entityType} ${found.text}) with this name, are you sure you wish to duplicate it?`, {color: "orange"})) {
                    await this.$store.dispatch("pushInHistory", this.entity);
                    this.addToRecent(this.entity);
                    this.$emit("entityChanged", this.entity);
                    return this.doSave(notify);
                } else {
                    // cancelled save
                    return false;
                }
            } else {
                await this.$store.dispatch("pushInHistory", this.entity);
                this.addToRecent(this.entity);
                this.$emit("entityChanged", this.entity);
                return this.doSave(notify);
            }
        } else {
            // don't push in history since it already got there via the edit method
            return this.doSave(notify);
        }
    }

    /**
     * Effectively saves whatever is currently being edited.
     * @returns {Promise<any>}
     */
    private async doSave(notify: boolean = true): Promise<boolean> {
        this.isNewModel = false;
        // todo: TypeScript interface detection?
        const model: any = this.entity as any;
        if (notify) {
            this.notify("Item was saved.", 1500, "green");
        }
        if (this.isEdge) {
            return this.dataService.upsertEdge(model as IEdgeModel);
        } else {
            return this.dataService.upsertNode(model as INodeModel);
        }
    }

    /**
     * Initializes a new entity.
     * @param entityType {EntityType} The type to create.
     * @returns {any}
     */
    createNewNode(entityType: EntityType | string) {
        this.isNewModel = true; // means it has not been merged into the project yet
        const model = ModelFactory.createNew(entityType);
        this.currentComponent = this.formMap[entityType];
        this.$store.dispatch("selectedModel", model);
        this.showEditPanels();
        return model;
    }

    /**
     * Initializes a new group.
     * @returns {any}
     */
    createNewGroup() {
        this.isNewModel = true; // means it has not been merged into the project yet
        const model = ModelFactory.createNew(EntityType.Group);
        this.currentComponent = this.formMap[EntityType.Group];
        this.$store.dispatch("selectedModel", model);
        this.showEditPanels();
        return model;
    }

    /**
     * Hides the group hierarchy.
     */
    hideParentGroupHierarchy() {
        this.parentHierarchy = [];
        this.isParentGroupVisible = false;
    }

    /**
     * Shows the hierarchy of groups for the current entity.
     * @returns {Promise<any[]>}
     */
    async showParentGroupHierarchy() {
        this.parentHierarchy = [];
        this.isParentGroupVisible = true;
        if (_.isNil(this.entity)) {
            return;
        }
        if (this.isEdge) {
            throw new Error("Trying to show the group hierarchy for an edge.");
        }
        if (this.isNewModel) {
            this.parentHierarchy = [];
        } else {
            this.parentHierarchy = await this.dataService.getGroupHierarchy(this.entity.id);
        }
        return this.parentHierarchy;
    }

    /**
     * Fetches the node of the given id.
     * @param id {string} A node id.
     * @returns {Promise<INodeModel>}
     */
    getNodeById(id: string): Promise<INodeModel> {
        return this.dataService.getNodeById(id);
    }

    /**
     * Displays the children contained in the current group.
     */
    async showGroupChildren() {
        if (_.isNil(this.entity)) {
            return;
        }
        if (!this.isGroup) {
            throw new Error("Attempt to show group children but the current entity is not a group.")
        }
        if (this.isNewModel) {
            this.groupChildren = [];
        } else {
            this.groupChildren = await this.dataService.getGroupChildren(this.entity.id);
        }

        this.groupChildrenVisible = true;
    }

    /**
     * Hides the panel with the group children.
     */
    hideGroupChildren() {
        this.groupChildren = [];
        this.groupChildrenVisible = false;
    }

    /**
     * Hides the parent entity panel.
     */
    hideParents() {
        this.parents = [];
        this.parentsVisible = false;
    }

    /**
     * Hides the children entity panel.
     */
    hideChildren() {
        this.childrenVisible = false;
    }

    /**
     * Show the parents for the current entity.
     */
    async showParents() {
        this.parents = [];
        if (_.isNil(this.entity)) {
            return;
        }
        this.parents = await this.dataService.getParents(this.entity.id);
        this.parentsVisible = true;
    }

    /**
     * Shows the starting panel.
     */
    async showInitialPanel() {
        this.initialItems = await this.dataService.getFavorites(10);
        this.someReminders = await this.dataService.getItemsOfType(EntityType.Reminder, 5);
        this.initialPanel = true;
    }

    /**
     * Hides the initial panel.
     */
    hideInitialPanel() {
        this.initialItems = [];
        this.initialPanel = false;
    }

    /**
     * Shows the panel with the children entities.
     */
    async showChildren() {
        this.children = [];
        if (_.isNil(this.entity)) {
            return;
        }
        this.children = await this.dataService.getChildren(this.entity.id);
        this.childrenVisible = true;
    }

    /**
     * Shows the panel with edge information.
     * @returns {Promise<void>}
     */
    async showEdgePanel() {
        const sourceId = (this.entity as EdgeBaseModel).sourceId;
        const targetId = (this.entity as EdgeBaseModel).targetId;
        this.sourceNode = await this.getNodeById(sourceId);
        this.targetNode = await this.getNodeById(targetId);
        this.edgePanelVisible = true;
    }

    /**
     * Hides the edge info.
     */
    hideEdgePanel() {
        this.edgePanelVisible = false;
    }

    /**
     * Sets the display to edit for the given node id.
     * @param id {string} A node id.
     * @param addToHistory
     */
    async editNode(id: string, addToHistory: boolean = true) {
        this.isMainVisible = true;
        const n = await this.setSelectedNode(id);
        this.currentComponent = this.formMap[n.entityType];
        this.showEditPanels();
        this.addToRecent(n);
        this.$emit("entityChanged", n);
        if (addToHistory) {
            await this.$store.dispatch("pushInHistory", n);
        }
    }

    private async addToRecent(entity: IRootModel) {
        await this.$store.dispatch("addRecent", entity);
        const ids = this.$store.state.recent.map(r => r.id);
        const plex = this.$store.state.plex;
        plex.recent = ids;
        await this.dataService.upsertPlex(plex);
    }

    /**
     * Sets the display to edit for the edge with the given id.
     * @param id {string} An edge id.
     * @param addToHistory
     */
    async editEdge(id: string, addToHistory: boolean = true) {
        this.isMainVisible = true;
        const e = await this.setSelectedEdge(id);
        this.currentComponent = this.formMap[EntityType.DefaultEdge];
        this.showEditPanels();
        this.addToRecent(e);
        this.$emit("entityChanged", e);
        if (addToHistory) {
            await this.$store.dispatch("pushInHistory", e);
        }

    }

    /**
     * Enables/disables visibility of the panels in function
     * of the current entity.
     */
    showEditPanels() {
        if (_.isNil(this.entity)) {
            this.hideParents();
            this.hideGroupChildren();
            this.hideChildren();
            this.hideParentGroupHierarchy();
            this.hideEdgePanel();
            this.isMainVisible = false;
            this.entityType = null;
            this.showInitialPanel();
        } else {
            this.isMainVisible = true;
            this.entityType = this.entity.entityType;
            this.hideInitialPanel();
            switch (this.entity.entityType) {

                case EntityType.Group:
                    this.showGroupChildren();
                    this.hideParents();
                    this.hideChildren();
                    this.showParentGroupHierarchy();
                    this.hideEdgePanel();
                    break;
                case EntityType.DefaultEdge:
                    this.hideGroupChildren();
                    this.hideParents();
                    this.hideChildren();
                    this.hideParentGroupHierarchy();
                    this.showEdgePanel();
                    this.entityType = "Edge"; // technical name is TaaskTaskEdge...not very nice to see
                    break;
                default:
                    this.hideGroupChildren();
                    this.showParents();
                    this.showChildren();
                    this.showParentGroupHierarchy();
                    this.hideEdgePanel();
                    break;
            }
        }
    }

    // endregion

    // region Main Search
    @Watch("mainSearchInput")
    onMainSearch(val) {
        this.mainSearch(val)
    }

    @Watch("mainSelected")
    async onMainSelected(v) {
        if (_.isNil(v)) {
            return;
        }
        this.isNewModel = false;
        await this.editNode(v.value);
        this.$nextTick(() => {
            this.mainSelected = null;
        })
    }

    async setSelectedNode(id: string): Promise<INodeModel> {
        this.isNewModel = false;
        const node = await this.getNodeById(id);
        await this.$store.dispatch("selectedModel", node);
        return node;
    }

    async setSelectedEdge(id: string) {
        this.isNewModel = false;
        const edge = await this.dataService.getEdgeById(id);
        await this.$store.dispatch("selectedModel", edge);
        return edge;
    }

    async mainSearch(v) {
        this.isMainSearchLoading = true;
        this.mainSearchItems = await this.dataService.searchName(v.text, true);
        this.isMainSearchLoading = false;
    }

    async getItem(id: string) {
        let found: IRootModel = await this.dataService.getNodeById(id);
        if (_.isNil(found)) {
            found = await this.dataService.getEdgeById(id);
        }
        return found;
    }

    async edit(id: string) {
        const found: any = await this.getItem(id);
        if (_.isNil(found)) {
            console.error("Failed to find a requested id");
            return;
        }
        if (found.sourceId) {
            return this.editEdge(id);
        } else {
            return this.editNode(id);
        }
    }

    // endregion

    // region Parent Group Search
    @Watch("parentGroupSearchInput")
    onParentGroupSearch(val) {
        this.parentGroupSearch(val)
    }

    @Watch("parentGroupSelected")
    async onParentGroupSelected(newParentGroup) {
        if (_.isNil(newParentGroup)) {
            return;
        }
        if (!_.isNil(this.entity)) {
            if (newParentGroup.value === this.entity.id) {
                this.notify("You can't make a group a parent of itself.", 3000, "#F44336");
            } else {
                (this.entity as NodeBaseModel).groupId = newParentGroup.value;
                await this.$store.dispatch("updateProperty", {propertyName: "parentId", value: newParentGroup.value});
                await this.dataService.setParentGroup(this.entity.id, newParentGroup.value);
                this.showParentGroupHierarchy();
            }
        }
    }


    async parentGroupSearch(v) {
        this.isParentGroupSearchLoading = true;

        if (this.isNewModel) {
            this.parentGroupSearchItems = [];
        } else {
            this.parentGroupSearchItems = await this.dataService.searchGroups(v.text);
        }
        this.isParentGroupSearchLoading = false;
    }

    // endregion

    // region Parents  Search
    @Watch("ancestorSearchInput")
    onAncestorSearch(val) {
        this.parentsSearch(val)
    }

    @Watch("ancestorSelected")
    onParentSelected(newAncestor) {
        if (_.isNil(newAncestor)) {
            return;
        }
        if (!_.isNil(this.entity)) {
            if (newAncestor.value === this.entity.id) {
                this.notify("You can't make an item a parent of itself", 2000, "red");
            } else {
                const edgeModel: EdgeBaseModel = ModelFactory.createNew(EntityType.DefaultEdge) as DefaultEdgeModel;
                edgeModel.sourceId = newAncestor.value;
                edgeModel.targetId = this.entity.id;
                this.dataService.upsertEdge(edgeModel);
            }
        }
        this.showParents();

    }


    async parentsSearch(v) {
        this.isAncestorSearchLoading = true;
        if (this.isNewModel) {
            this.ancestorSearchItems = [];
        } else {
            this.ancestorSearchItems = await this.dataService.searchName(v.value, false);
        }
        this.isAncestorSearchLoading = false;
    }

    // endregion

    // region Child  Search
    @Watch("successorSearchInput")
    onSuccessorSearch(val) {
        this.successorSearch(val)
    }

    @Watch("successorSelected")
    async onSuccessorSelected(newSuccessor) {
        if (_.isNil(newSuccessor)) {
            return;
        }
        if (!_.isNil(this.entity)) {
            if (newSuccessor.value === this.entity.id) {
                this.notify("You can't make an item a child of itself.", 2000, "#F44336");
            } else {
                const edgeModel: EdgeBaseModel = ModelFactory.createNew(EntityType.DefaultEdge) as EdgeBaseModel;
                edgeModel.sourceId = this.entity.id;
                edgeModel.targetId = newSuccessor.value;
                await this.dataService.upsertEdge(edgeModel);
            }
        }
        this.showChildren();

    }


    async successorSearch(v) {
        this.isSuccessorSearchLoading = true;
        if (this.isNewModel) {
            this.successorSearchItems = [];
        } else {
            this.successorSearchItems = await this.dataService.searchName(v.value, false);
        }

        this.isSuccessorSearchLoading = false;
    }

    // endregion

    // region Child  Search
    @Watch("childSearchInput")
    onChildSearch(val) {
        this.childSearch(val)
    }

    @Watch("childSelected")
    async onChildSelected(newChild) {
        if (_.isNil(newChild)) {
            return;
        }
        if (!_.isNil(this.entity)) {
            if (newChild.value === this.entity.id) {
                this.notify("You can't make an item a child of itself.", 3000, "#F44336");
            } else {
                const node = await this.getNodeById(newChild.value);
                node.groupId = this.entity.id;
                await this.dataService.upsertNode(node);
            }
        }
        this.showGroupChildren();
        this.$nextTick(() => {
            this.childSelected = null;
        })
    }


    async childSearch(v) {
        this.isChildSearchLoading = true;
        if (this.isNewModel) {
            this.childSearchItems = [];
        } else {
            this.childSearchItems = await this.dataService.searchName(v.value, true);
        }
        this.isChildSearchLoading = false;
    }

    // endregion
    notify(text: string, timeout: number = 2000, color: string = "white") {
        this.notificationText = text;
        this.notificationTimeout = timeout;
        this.notificationColor = color;
        this.isNotificationVisible = true;
    }


    toggleFavorite() {
        if (this.isEntityPresent && this.isNode) {
            (this.entity as any).isFavorite = !(this.entity as any).isFavorite;
            this.save(false);
        }
    }

    async detachFromGroup() {
        if (!_.isNil(this.entity)) {
            await this.dataService.setParentGroup(this.entity.id, null);
            this.showParentGroupHierarchy();
        }
    }

    /**
     * Creates a new group and puts the current entity into it.
     * The new group becomes thereafter the current entity.
     * @returns {Promise<void>}
     */
    async addLinkGroup() {
        const group = ModelFactory.createNew(EntityType.Group);
        await this.dataService.upsertNode(group as INodeModel);
        (this.entity as INodeModel).groupId = group.id;
        await this.save(false);
        await this.editNode(group.id);
    }

    /**
     * Creates a new entity linked to the current one with the given direction.
     * The new entity becomes thereafter the current entity.
     * @param entityType {EntityType|string} The new type to create.
     * @param direction {string} Should be 'incoming' or 'outgoing'.
     * @returns {Promise<void>}
     */
    async addLinkEntity(entityType: EntityType | string, direction: string = "incoming") {
        if (!(direction === "incoming" || direction === "outgoing")) {
            throw new Error(`The given direction '${direction}' is not recognized.`);
        }
        this.incomingDrawerVisible = false;
        this.outgoingDrawerVisible = false;
        const newEntity = ModelFactory.createNew(entityType) as INodeModel;
        await this.dataService.upsertNode(newEntity);
        const edge = ModelFactory.createNew(EntityType.DefaultEdge) as IEdgeModel;
        if (direction === "incoming") {
            edge.sourceId = newEntity.id;
            edge.targetId = this.entity.id;
        } else {
            edge.targetId = newEntity.id;
            edge.sourceId = this.entity.id;
        }
        await this.dataService.upsertEdge(edge);
        await this.save(false);
        await this.editNode(newEntity.id);
    }

    toggleIncomingDrawer() {
        this.incomingDrawerVisible = !this.incomingDrawerVisible;
    }

    toggleOutgoingDrawer() {
        this.outgoingDrawerVisible = !this.outgoingDrawerVisible;
    }
}


